import { storageGetItem } from "@/utils/utils";

const GROUP_A_NAME = 'TemplateTest10A';
const GROUP_B_NAME = 'TemplateTest10B';

function getGroupId(){
    if(!window.ip) return ''
    if(ipIsOdd(window.ip)){
        return GROUP_A_NAME;
    }

    return GROUP_B_NAME;
}
function ipIsOdd(ip){
    if(!ip)return false;
    let lastNum = parseInt(ip.split('.').pop());
    if(lastNum%2===0){// even number
        return false;
    }
    return true;

}
function getIp (callback) {
    callback && callback();
    return ''
    // return testGroupId in callback
    let groupId;
    if(!window.ip && window.localStorage){
        let deviceIp =  storageGetItem(localStorage, "online.data.ip");
        if(deviceIp)
            window.ip = deviceIp;
    }

    if(window.ip){
        groupId=getGroupId();
        return callback && typeof callback==='function' && callback(groupId)
    }
}


export default class GoogleAnalyticsApis  {
    constructor() {
        this.jRsRgaSend = this.jRsRgaSend.bind(this);
        this.jRsRgaSendSocial = this.jRsRgaSendSocial.bind(this);
        // this.sendGAInfoByTools = this.sendGAInfoByTools.bind(this);
        // this.sendGAByFoxitOnlineTools = this.sendGAByFoxitOnlineTools.bind(this);
    }
    setUserId(id){
        window.ga && window.ga('set', 'userId', id);
    }
    jRsRgaSendSocial (siteName, toolName, baseUrl) {
        getIp(function (groupId) {
            let post = !!groupId? '_' + groupId:'';
            /*ga('send', 'social', {
                'socialNetwork': siteName,
                'socialAction': 'share_' + groupId,
                'socialTarget': baseUrl
            });*/
            window.ga('send', {
                hitType: 'social',
                socialNetwork: siteName,
                socialAction: 'share_' + toolName + post,
                socialTarget: baseUrl
            });
        });
    }
    
    /**
     *
     * @param {String} label
     * @param {String} category
     * @param {String} action
     * @param {String} value
     * @returns {Promise}
     */
    jRsRgaSend (label, category, action, value) {
        return new Promise(function(resolve, /* reject */) {
            if (!label) {
                return;
            }
            if (!action) {
                action = label;
            }
            getIp(function(groupId){
                if (typeof window.ga !== 'function') {
                    return;
                }
                if (!category) {
                    category = 'Template JR';
                }
                let post = !!groupId? '_' + groupId:'';
                if (!value) {
                    window.ga('send', 'event', category, action + post, label);
                } else {
                    window.ga('send', 'event', category, action + post, label,value);
                }
    
                resolve();
            });
        });
    }
   
}




